import { useEffect } from "react";

export default function useScrollLock(lock) {
  /**
   * Custom hook to lock or unlock the scroll of the body.
   * @param {boolean} lock - If true, locks the scroll; if false, unlocks it.
   */
  useEffect(() => {
    // Get the scrolling element (body or documentElement)
    const target = document.scrollingElement || document.body;
    if (lock) {
      // Lock the scroll by setting overflow to hidden
      target.style.overflow = "hidden";
    } else {
      target.style.overflow = "";
    }
    // Cleanup function to reset the overflow style when the component unmounts or lock changes
    return () => {
      target.style.overflow = "";
    };
  }, [lock]);
}
